import { Button, NumberInput, Textarea } from "@mantine/core";
import { useFormRender } from "../hooks/useFormRender";
import { ENUM_FORM_DISPLAY } from "./pageList";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/userServerApi";
import RemoteSelect2 from "./remoteSelect2";
import { useState, useEffect, useMemo } from "react";
import { useFormatter } from "../hooks/useFomatter";

const ClientRefundCreditButton = ({ mainForm }) => {
  const { t } = useTranslation();
  const [api] = useServerApi();
  const [currentCredit, setCurrentCredit] = useState(0);
  const clientId = mainForm?.values?._id;
  const [formatter] = useFormatter();
  const fetchCredit = async () => {
    try {
      if (!clientId) return;
      const credit = await api.Client.getAvailableCredit(clientId);
      setCurrentCredit(credit.balance);
    } catch (error) {
      console.log("Error fetching credit:", error);
    }
  };

  useEffect(() => {
    fetchCredit();
  }, [clientId]);

  // Create dynamic form schema that updates when currentCredit changes
  const formSchema = useMemo(
    () => ({
      title: "Refund Credit",
      display: {
        mode: ENUM_FORM_DISPLAY.MODAL,
        size: "1000px", //xs, sm, xl  ....100%
        // position:"right"
      },
      closeAfterSave: true,
      showSaveBar: true,
      apiEntity: "client",

      validate: {
        credit: (value) =>
          value <= 0 ? "Credit must be greater than 0" : null,
      },
      initialValues: {
        credit: currentCredit,
        remark: "Refund Credit to Client.",
      },

      layout: {
        containers: [],
        fields: [
          {
            name: "credit",
            component: NumberInput,
            parent: "section-credit",
            props: {
              required: true,
              label: "Credit",
              placeholder: "Credit",
              parser: formatter.currencyParser,
              formatter: formatter.currencyFormat,
              precision: 2,
            },
          },
          //remark
          {
            name: "remark",
            component: Textarea,
            parent: "section-credit",
            props: {
              required: true,
              label: "Remark",
              placeholder: "Remark",
            },
          },
        ],
      },
    }),
    [currentCredit]
  );

  const handleActionClick = () => {
    const id = mainForm?.values?._id;
    if (!id) return;

    // Pass the current credit as initial data to the form
    const initialData = {
      credit: currentCredit,
      remark: "Refund Credit to Client. ",
    };

    formAction.open({ mode: "edit", id, data: initialData });
  };

  const refundCredit = async (credit, remark) => {
    try {
      if (!credit || !clientId) return;
      const response = await api.Client.refundCredit(clientId, credit, remark);
      //   console.log("Credit updated:", response);
      mainForm.reload();
    } catch (error) {
      console.log("Error updating credit:", error);
    }
  };

  const onSubmit = ({ values, formMode }) => {
    try {
      //   console.log("onSubmit", values);
      refundCredit(values.credit, values.remark);
    } catch (error) {
      console.log("Error transferring credit:", error);
    }
  };

  const onSubmitSuccess = () => {
    // console.log("onSubmitSuccess");
    formAction.close();
  };

  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    formSchema,
    onSubmitSuccess,
    onSubmit
  );

  return (
    <>
      <Button
        fullWidth
        onClick={handleActionClick}
        disabled={currentCredit <= 0}
      >
        {t("Refund Credit")}
      </Button>

      {renderForm()}
    </>
  );
};

export default ClientRefundCreditButton;
